import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAppSelector, useAppDispatch } from '@app/store/hooks';
import { endpoints } from '@app/api/apis';
import { updateUserProfile } from '@app/store/slices/authSlice';

const useUserProfile = () => {
  const dispatch = useAppDispatch();
  const accountId = useAppSelector((state) => state.auth.userDetails?.linkedApplications[0]?.accountId);
  const userProfile = useAppSelector((state) => state.auth.userProfile);
  const [isLoading, setIsLoading] = useState(false);

  const fetchUserProfile = async () => {
    if (!accountId) return;
    
    setIsLoading(true);
    try {
      const url = endpoints.userProfile + accountId;
      const res = await axios.get(url);
      dispatch(updateUserProfile(res?.data ?? {}));
    } catch (err) {
      console.log('fetchUserProfile', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (accountId && (!userProfile || Object.keys(userProfile).length === 0)) {
      fetchUserProfile();
    }
  }, [accountId]);

  return {
    userProfile,
    isLoading,
    fetchUserProfile,
    hasData: userProfile && Object.keys(userProfile).length > 0
  };
};

export default useUserProfile;